import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../global';
import { Adjunto } from '../domain/adjunto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdjuntoService {

  urlAdjunto: string;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-10-08
   * @param httpClient
   */
  constructor(
    public httpClient: HttpClient
  ) {
    this.urlAdjunto = GLOBAL.URL_BASE + 'sicaAdjunto';
  }

  /**
  * @author Daniel Pareja Londoño
  * @version 2018-10-10
  * @param id
  */
  getAdjuntoById(id: number): any {
    return this.httpClient.get(this.urlAdjunto + '/getAdjunto/' + id);
  }

    /**
   * @author Freddy Sebastian Garcia Victoria
   * @version 2018-10-17
   * @param adjunto 
  */
  saveAdjuntoToS3(adjunto: Adjunto): Observable<any> {
    return this.httpClient.post(this.urlAdjunto + '/saveAdjuntoToS3/', adjunto, this.httpOptions);
  }
  
  /**
   * @author Freddy Sebastian Garcia Victoria
   * @version 2018-10-18
   * @param adjunto 
  */
 inactiveSicaAdjuntoAmazonS3(adjunto: Adjunto): Observable<any> {
    return this.httpClient.put(this.urlAdjunto + '/inactiveAdjuntoToS3/', adjunto, this.httpOptions);
  }

  /**
   * @author Freddy Sebastian Garcia Victoria
   * @version 2018-10-18
   * @param adjunto 
  */
 modifyUploadedSicaAdjuntoAmazonS3(adjunto: Adjunto): Observable<any> {
    return this.httpClient.put(this.urlAdjunto + '/modifyUploadedAdjuntoToS3/', adjunto, this.httpOptions);
  }

  /**
   * 
   * @param idMeno 
   * @param idTerc 
   */
  generateReportNewMessage(idMeno: number, idTerc: number): any {
    return this.httpClient.get(this.urlAdjunto + '/generateReportNewMessage/' + idMeno + '/' + idTerc);
  }

}
